import intl from 'react-intl-universal'
import { ToastService, Toastr } from './toastService.types'

function toastService(this: ToastService, toastr: Toastr) {
  let offlineToast

  this.showOffline = () => {
    if (!offlineToast || !offlineToast.isOpened) {
      offlineToast = toastr.warning(intl.get('common.offline'), {
        timeOut: 0,
        extendedTimeOut: 0,
        tapToDismiss: false,
      })
    }
  }

  this.hideOffline = () => {
    toastr.clear(offlineToast)
  }
}

export default ['toastr', toastService]
